import { render, staticRenderFns } from "./TaskSuccessors.vue?vue&type=template&id=0882cfa4&scoped=true&"
import script from "./TaskSuccessors.vue?vue&type=script&lang=js&"
export * from "./TaskSuccessors.vue?vue&type=script&lang=js&"
import style0 from "./TaskSuccessors.vue?vue&type=style&index=0&id=0882cfa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882cfa4",
  null
  
)

export default component.exports